var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_192_520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3809 15.3809C16.207 14.5635 17.543 14.5635 18.29 15.3809L22.4209 19.5205L26.6309 15.3809C27.457 14.5635 28.793 14.5635 29.54 15.3809C30.4365 16.207 30.4365 17.543 29.54 18.29L25.4795 22.4209L29.54 26.6309C30.4365 27.457 30.4365 28.793 29.54 29.54C28.793 30.4365 27.457 30.4365 26.6309 29.54L22.4209 25.4795L18.29 29.54C17.543 30.4365 16.207 30.4365 15.3809 29.54C14.5635 28.793 14.5635 27.457 15.3809 26.6309L19.5205 22.4209L15.3809 18.29C14.5635 17.543 14.5635 16.207 15.3809 15.3809ZM45 22.5C45 34.9277 34.9277 45 22.5 45C10.0723 45 0 34.9277 0 22.5C0 10.0723 10.0723 0 22.5 0C34.9277 0 45 10.0723 45 22.5ZM22.5 4.21875C12.4014 4.21875 4.21875 12.4014 4.21875 22.5C4.21875 32.5986 12.4014 40.7812 22.5 40.7812C32.5986 40.7812 40.7812 32.5986 40.7812 22.5C40.7812 12.4014 32.5986 4.21875 22.5 4.21875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_192_520"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.b935d22ec45c57ce5cab5a5d2b862d11.svg";
export { ForwardRef as ReactComponent };